module.exports = __webpack_public_path__ + "img/logo.b20915b3.png";